import { useLang } from '@/i18n';
import EcoSpace from 'eco-design/base/eco-space';
import EcoSectionCard from 'eco-design/sections/eco-section-card';
import styles from './index.module.scss';

export default function Comp() {
    const { t } = useLang('theProduct');

    return (
        <div className={styles.comp} id="SectionC">
            <EcoSpace />
            <EcoSectionCard
                layout="center-left"
                title={t('J_title')}
                desc={t('J_desc')}
                pc="https://websiteoss.ecoflow.com/upload/image/1744343310009/t2.jpg"
                pad="https://websiteoss.ecoflow.com/upload/image/1744343310009/t2.jpg"
                h5="https://websiteoss.ecoflow.com/upload/image/1744343309796/t2-h5.jpg"
            />
        </div>
    );
}
